import React from "react"
import badge from "badges/memory-applications.svg"
import { BadgeImage } from "backpack/badges/styled"

const MemoryApplications = props => <BadgeImage src={badge} {...props} />

export default MemoryApplications
